import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Select from 'react-select'
import styles from './styles.css'

export default class SelectField extends Component {
  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.any,
    label: PropTypes.string,
    errorMessage: PropTypes.string,
    disabled: PropTypes.bool,
    options: PropTypes.array,
  }

  renderLabel() {
    if (this.props.label)
      return (
        <label className="input-label-enabled-color input-label-text">{this.props.label}</label>
      )
  }

  renderError() {
    if (!this.props.errorMessage) return
    return <div className="os-input-error">{this.props.errorMessage}</div>
  }

  render() {
    return (
      <div className={`${styles.SelectField} col`}>
        {this.renderLabel()}
        <div className={`${styles.input_container}`}>
          <Select
            className={`${styles.input} h-12`}
            classNamePrefix="select"
            isDisabled={false}
            isClearable={true}
            isRtl={false}
            isSearchable={true}
            onChange={this.props.onChange}
            value={this.props.value}
            options={this.props.options}
          />
        </div>
        {this.renderError()}
      </div>
    )
  }
}
